import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=81c3b334&scoped=true&"
import script from "./MyTable.vue?vue&type=script&lang=js&"
export * from "./MyTable.vue?vue&type=script&lang=js&"
import style0 from "./MyTable.vue?vue&type=style&index=0&id=81c3b334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3b334",
  null
  
)

export default component.exports